var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4C2.9 4 2 4.9 2 6V9.15039C2 9.56539 2.23786 9.97056 2.63086 10.1016C3.42486 10.3676 4 11.12 4 12C4 12.88 3.42486 13.6324 2.63086 13.8984C2.23786 14.0294 2 14.4346 2 14.8496V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V14.8496C22 14.4346 21.7621 14.0294 21.3691 13.8984C20.5751 13.6324 20 12.88 20 12C20 11.12 20.5751 10.3676 21.3691 10.1016C21.7621 9.97056 22 9.56539 22 9.15039V6C22 4.9 21.1 4 20 4H4ZM12 6.80078L13.4004 10.0996L17 10.4004L14.3008 12.8008L15.0996 16.1992L12 14.4004L8.90039 16.3008L9.69922 12.8008L7 10.4004L10.5996 10.0996L12 6.80078Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.c348f7acbaf2f23fe1ca6e393e6a002a.svg";
export { ForwardRef as ReactComponent };